import { getStore } from "../../Providers/store";
import PActions from "../../Stores/redux/Persist/Actions";

export const initAuth = async () => {
  let store = getStore();

  if (store) {
    store.dispatch(PActions.fetchMyProfile());
  }
};
